<template>
  <ul class="error--text">
    <li v-for="(values, key) in data.errors" :key="key">
      <strong>{{ key }}</strong>

      <ul>
        <li v-for="val in values" :key="`${key}-${val}`">{{ val }}</li>
      </ul>
    </li>
  </ul>
</template>

<script>
export default {
  name: "ValidationError",

  props: {
    data: {
      /** @type {PropType<ValidationResponse>} */
      type: Object,
      required: true,
    },
  },
};
</script>

<style scoped></style>
